<div class="pricing-page h-full overflow-x-hidden overflow-y-auto font-sans relative">
    <img [src]="'images/pricing_orange_vector.png' | assetUrl" alt="Orange Vector"
        class="absolute -top-10 -left-10 w-[5rem] sm:w-[15rem] lg:w-[20rem] h-auto object-contain opacity-50 pointer-events-none hidden sm:block">
    <img [src]="'images/pricing_blue_vector.png' | assetUrl" alt="Blue Vector"
        class="absolute -top-10 -right-10 w-[5rem] sm:w-[15rem] lg:w-[20rem] h-auto object-contain opacity-50 pointer-events-none hidden sm:block">

    <!-- Loading Screen -->
    <div class="h-screen flex items-center justify-center" *ngIf="ui.isLoading">
        <div class="flex flex-col items-center justify-center gap-2">
            <h2 class="text-xl sm:text-2xl font-bold">{{"Loading your pricing options..." | textCase}}</h2>
            <p class="text-gray-500 text-sm sm:text-base">{{"Please wait while we fetch your plan details" | textCase}}
            </p>
        </div>
    </div>

    <!-- Main Content -->
    <div class="w-full max-w-[80rem] mx-auto px-4 sm:px-6 py-4 sm:py-6 pb-8 sm:pb-12 flex flex-col gap-12 animate-fadeInUp"
        *ngIf="!ui.isLoading">
        <div class="mt-4 text-center flex-shrink-0 w-full">
            <h1 class="text-xl sm:text-2xl lg:text-3xl mb-3 leading-tight font-bold px-2 theme-text font-bricolage">
                Find the smartest plan for your team
            </h1>
            <p class="text-xs sm:text-sm lg:text-base m-0 px-2">
                Bob pricing is designed to match real construction workflows and project demands.
            </p>


        </div>
        <div class="w-full flex flex-col gap-3">
            <!-- Entity Type Toggle - Show only if any plan has multiple entity types -->
            @if(hasPlansWithMultipleEntities) {
            <div class="flex items-center justify-center gap-6">
                <span class="text-sm text-gray-700 font-medium">{{"Filter by" | textCase}}:</span>
                @for(entity of EntityUnit | keyvalue; track entity.key) {
                <label class="flex items-center gap-2 cursor-pointer">
                    <input type="radio" name="entity-filter" [value]="entity.value" [(ngModel)]="selectedEntityType"
                        (change)="onTopLevelEntityChange(entity.value)"
                        class="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500">
                    <span class="text-sm text-gray-900">{{entity.value | textCase}}</span>
                </label>
                }
            </div>
            }
            <!-- Pricing Cards -->
            <!-- Pricing Plans Carousel -->
            <app-carousel [items]="filteredPlans" [options]="{ align: 'end', loop: false, skipSnaps: false }"
                [breakpoints]="{ mobile: 'full', tablet: '1/2', desktop: '1/3', largeDesktop: '1/3', extraLargeDesktop: '1/4' }"
                [spacing]="'4'" [wrapperClass]="'w-full mb-6 px-4 md:px-12'" [trackBy]="trackByPlanId">
                <ng-template #itemTemplate let-plan>
                    <div class="h-full flex items-end">
                        <div class="flex flex-col min-w-[20rem] max-w-[20rem] w-full">
                            <!-- Current Plan Badge Wrapper -->
                            @if(isCurrentPlan(plan)) {
                            <div [ngClass]="getStatusColorClass(plan).badge"
                                class="text-white text-xs font-semibold py-2 px-3 rounded-t-2xl text-center mb-0 w-full">
                                <span class="flex items-center justify-center gap-1.5">
                                    <app-icon
                                        [type]="orgIsPaymentFailed() ? 'pi pi-exclamation-circle' : orgIsPaymentUnpaid() ? 'pi pi-exclamation-triangle' : 'pi pi-check-circle'"
                                        source="primeng" size="sm"></app-icon>
                                    <span>Current plan: {{ getStatusText() | textCase }}</span>
                                </span>
                            </div>
                            }

                            <!-- Card -->
                            <ng-container
                                *ngTemplateOutlet="planCardTemplate; context: { $implicit: getPlanContext(plan), plan: plan, statusColors: getStatusColorClass(plan) }"></ng-container>
                        </div>
                    </div>
                </ng-template>
            </app-carousel>
        </div>

    </div>

    <!-- Contact Sales Modal -->
    @if(ui.showContactSalesModal) {
    <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-[1000] backdrop-blur-sm p-2 sm:p-4"
        (click)="closeContactSalesModal()">
        <div class="bg-white rounded-lg sm:rounded-xl shadow-[0_10px_30px_rgba(0,0,0,0.2)] w-full max-w-[95vw] sm:max-w-[85vw] md:max-w-[600px] lg:max-w-[700px] max-h-[95vh] sm:max-h-[90vh] overflow-y-auto relative"
            (click)="$event.stopPropagation()">
            <div
                class="flex justify-between items-center px-4 sm:px-6 pt-4 pb-3 border-b border-gray-100 mb-4 sticky top-0 bg-white z-10">
                <h2 class="text-xl sm:text-2xl font-semibold text-[#333] m-0">{{"Contact sales" | textCase}}</h2>
                <button
                    class="bg-transparent border-none text-lg sm:text-xl text-[#666] cursor-pointer p-2 rounded transition-all duration-200 hover:bg-gray-100 hover:text-[#333]"
                    (click)="closeContactSalesModal()">
                    <i class="pi pi-times"></i>
                </button>
            </div>

            <form [formGroup]="contactForm" class="px-4 sm:px-6 pb-4" (ngSubmit)="submitContactForm()">
                <div class="mb-3">
                    <label class="block text-xs sm:text-sm font-medium text-[#333] mb-1.5">{{"Full name" |
                        textCase}}<span class="text-red-500 ml-0.5">*</span></label>
                    <input type="text"
                        class="w-full px-3 py-2.5 sm:py-3 border border-gray-300 rounded-md text-xs sm:text-sm transition-colors duration-200 box-border focus:outline-none focus:border-orange-500 focus:shadow-[0_0_0_2px_rgba(255,107,53,0.1)] placeholder:text-gray-400"
                        placeholder="Enter here" formControlName="fullName">
                    <div *ngIf="contactForm.get('fullName')?.invalid && contactForm.get('fullName')?.touched"
                        class="text-red-500 text-xs mt-1 leading-tight">
                        {{"Full name is required" | textCase}}
                    </div>
                </div>

                <div class="mb-3">
                    <label class="block text-xs sm:text-sm font-medium text-[#333] mb-1.5">{{"Email" | textCase}}<span
                            class="text-red-500 ml-0.5">*</span></label>
                    <input type="email"
                        class="w-full px-3 py-2.5 sm:py-3 border border-gray-300 rounded-md text-xs sm:text-sm transition-colors duration-200 box-border focus:outline-none focus:border-orange-500 focus:shadow-[0_0_0_2px_rgba(255,107,53,0.1)] placeholder:text-gray-400"
                        placeholder="Enter here" formControlName="email">
                    <div *ngIf="contactForm.get('email')?.invalid && contactForm.get('email')?.touched"
                        class="text-red-500 text-[0.65rem] sm:text-xs mt-1 leading-tight">
                        <div *ngIf="contactForm.get('email')?.errors?.['required']">{{"Email is required" | textCase}}
                        </div>
                        <div *ngIf="contactForm.get('email')?.errors?.['email']">Please enter a valid email</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label class="block text-xs sm:text-sm font-medium text-[#333] mb-1.5">{{"Phone" | textCase}}<span
                            class="text-red-500 ml-0.5">*</span></label>
                    <app-phone-input formControlName="phoneNumber" (phoneNumberChange)="onPhoneNumberChange($event)"
                        appendTo="body">
                    </app-phone-input>
                    <div *ngIf="contactForm.get('phoneNumber')?.invalid && contactForm.get('phoneNumber')?.touched"
                        class="text-red-500 text-[0.65rem] sm:text-xs mt-1 leading-tight">
                        {{"Please enter a valid phone number" | textCase}}
                    </div>
                </div>

                <div class="mb-3">
                    <label class="block text-xs sm:text-sm font-medium text-[#333] mb-1.5">{{"Company" | textCase}}<span
                            class="text-red-500 ml-0.5">*</span></label>
                    <input type="text"
                        class="w-full px-3 py-2.5 sm:py-3 border border-gray-300 rounded-md text-xs sm:text-sm transition-colors duration-200 box-border focus:outline-none focus:border-orange-500 focus:shadow-[0_0_0_2px_rgba(255,107,53,0.1)] placeholder:text-gray-400"
                        placeholder="Enter here" formControlName="company">
                    <div *ngIf="contactForm.get('company')?.invalid && contactForm.get('company')?.touched"
                        class="text-red-500 text-[0.65rem] sm:text-xs mt-1 leading-tight">
                        {{"Company is required" | textCase}}
                    </div>
                </div>

                <div class="mb-3">
                    <label class="block text-xs sm:text-sm font-medium text-[#333] mb-1.5">{{"Message" | textCase}}<span
                            class="text-red-500 ml-0.5">*</span></label>
                    <textarea
                        class="w-full px-3 py-2.5 sm:py-3 border border-gray-300 rounded-md text-xs sm:text-sm font-[inherit] resize-y min-h-[5rem] sm:min-h-[6.25rem] box-border transition-colors duration-200 focus:outline-none focus:border-orange-500 focus:shadow-[0_0_0_2px_rgba(255,107,53,0.1)] placeholder:text-gray-400"
                        placeholder="Enter here" formControlName="message"></textarea>
                    <div *ngIf="contactForm.get('message')?.invalid && contactForm.get('message')?.touched"
                        class="text-red-500 text-[0.65rem] sm:text-xs mt-1 leading-tight">
                        {{"Message is required" | textCase}}
                    </div>
                </div>

                <button type="submit"
                    class="w-full bg-orange-500 text-white border-none px-4 py-3 sm:py-3.5 rounded-md text-xs sm:text-sm font-semibold cursor-pointer transition-all duration-200 hover:bg-[#e55a2b] hover:-translate-y-0.5 hover:shadow-[0_4px_12px_rgba(255,107,53,0.3)] active:translate-y-0 disabled:opacity-50 disabled:cursor-not-allowed">{{"Submit"
                    | textCase}}</button>
            </form>
        </div>
    </div>
    }

    <!-- Success Dialog -->
    @if(ui.showSuccessDialog) {
    <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-[1000] backdrop-blur-sm p-4"
        (click)="closeSuccessDialog()">
        <div class="bg-white rounded-lg sm:rounded-xl shadow-[0_10px_30px_rgba(0,0,0,0.2)] max-w-[90%] sm:max-w-[25rem] w-full relative text-center"
            (click)="$event.stopPropagation()">
            <button
                class="absolute top-3 right-3 sm:top-4 sm:right-4 z-10 bg-transparent border-none text-base sm:text-lg text-[#666] cursor-pointer p-1.5 sm:p-2 rounded transition-all duration-200 hover:bg-gray-100 hover:text-[#333]"
                (click)="closeSuccessDialog()">
                <i class="pi pi-times"></i>
            </button>

            <div class="p-6 sm:p-8">
                <div
                    class="w-14 h-14 sm:w-16 sm:h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i class="pi pi-check text-white text-xl sm:text-2xl font-bold"></i>
                </div>

                <h2 class="text-lg sm:text-xl lg:text-2xl font-bold text-[#333] m-0 mb-2">{{"Request submitted!" |
                    textCase}}</h2>
                <p class="text-xs sm:text-sm lg:text-base text-[#666] m-0 mb-6 leading-[1.4]">{{"Our team will reach out
                    to you shortly" | textCase}}</p>

                <button
                    class="bg-orange-500 text-white border-none px-6 sm:px-8 py-2.5 sm:py-3 rounded-md text-xs sm:text-sm font-semibold cursor-pointer transition-all duration-200 hover:bg-[#e55a2b] hover:-translate-y-0.5 hover:shadow-[0_4px_12px_rgba(255,107,53,0.3)]"
                    (click)="goBackToHome()">{{"Go back to home" | textCase}}</button>
            </div>
        </div>
    </div>
    }

    <!-- Checkout Dialog -->
    @if(ui.showCheckoutDialog) {
    <app-checkout-dialog [(visible)]="ui.showCheckoutDialog" [plan]="ui.selectedPlan" [plans]="plans"
        [selectedEntityType]="selectedEntityType" [isDowngrade]="ui.isPendingDowngrade" [sourcePlan]="getOrgPlan()"
        [source]="CheckoutSource.ORG_PLAN_CHANGE" (onProceed)="proceedToCheckout($event)">
    </app-checkout-dialog>
    }

    <!-- Cancel Subscription Dialog -->
    <app-dialog [(visible)]="ui.showCancelDialog" [title]="'Cancel subscription' | textCase"
        [description]="'Are you sure you want to cancel your subscription? You will retain access until the end of your current billing cycle.' | textCase"
        class="max-w-[28rem]" (closed)="closeCancelDialog()">
        <ng-template #bodyTemplate>
            @if(billingCycleEndDate) {
            <div class="bg-amber-50 border border-amber-200 rounded-lg px-4 py-3 text-sm text-amber-800">
                <i class="pi pi-info-circle mr-1.5"></i>
                {{"Access ends on" | textCase}}: <strong>{{ billingCycleEndDate | date:'mediumDate' }}</strong>
            </div>
            }
        </ng-template>
        <ng-template #footerTemplate>
            <div class="flex gap-3 justify-end w-full">
                <app-button [label]="'Cancel subscription' | textCase" variant="filled" severity="danger"
                    [loading]="ui.isCancellingSubscription" [disabled]="ui.isCancellingSubscription"
                    (clicked)="confirmCancelSubscription()" />
            </div>
        </ng-template>
    </app-dialog>

    <!-- Plan Card Template -->
    <ng-template #planCardTemplate let-planContext let-originalPlan="plan" let-statusColors="statusColors">
        <div
            [class]="'flex flex-col min-h-[35rem] justify-between border !bg-white z-10 shadow-sm hover:shadow-lg transition-shadow duration-300 w-full ' + (isCurrentPlan(originalPlan) ? 'border border-t-4 ' + statusColors.border + ' rounded-b-2xl rounded-t-none' : 'border border-gray-200 rounded-2xl')">

            <!-- Card Header -->
            <div class="flex flex-col">
                <div class="flex flex-col gap-3 p-6">
                    <!-- Plan Name -->
                    <div class="flex flex-col gap-2">
                        <h3 class="text-2xl font-bold text-gray-900 m-0">
                            {{ planContext.name }}
                        </h3>
                        @if(planContext.description) {
                        <span class="text-sm text-gray-600 m-0 leading-relaxed truncate-2-lines">
                            {{ planContext.description }}
                        </span>
                        }
                    </div>

                    <!-- Price Section -->
                    @if(shouldShowPriceToCustomer(originalPlan)) {
                    <div class="flex items-baseline gap-2">
                        <span class="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">
                            ${{ getCurrentPrice(planContext).price }}
                        </span>
                        <span class="text-sm text-gray-500">
                            /{{ getCurrentPrice(planContext).entity | textCase:CASE_TYPE.LOWER }}/{{
                            TERM_UNIT_LABELS[getCurrentPrice(planContext).term] | textCase:CASE_TYPE.LOWER
                            }}
                        </span>
                    </div>
                    @if(hasMultipleTermsForSelectedEntity(planContext)) {
                    <app-select-button [options]="planContext.priceViewOptions" [(ngModel)]="planContext.currentView"
                        (selectionChange)="onViewModeChange(planContext, $event)" size="small" variant="rounded"
                        severity="ai-light-gradient">
                    </app-select-button>
                    }
                    }
                </div>
            </div>

            <!-- Card Body -->
            <div class="flex flex-col h-[20rem]">
                <!-- Divider -->
                <hr class="border-gray-200">
                <div class="flex flex-col p-6 gap-3 h-full">
                    <!-- Features List -->
                    <div class="flex flex-col gap-3 flex-1 min-h-0 overflow-y-auto show-scrollbar pr-2">
                        @for(feature of planContext.descriptionPoints; let index = $index; track index +
                        feature) {
                        <div class="flex items-start gap-1">
                            <span class="flex-shrink-0 bob-agent-tick-icon"
                                [innerHTML]="SVG.BOB_AGENT_TICK | sanitizeHtml"></span>
                            <span class="text-sm  text-gray-700">
                                {{ feature }}
                            </span>
                        </div>
                        }
                    </div>

                    <!-- Action Button -->
                    <div class="w-full flex-shrink-0 flex flex-col gap-2">

                        @if(isSalesPaymentMode) {
                        <app-button (clicked)="handleContactSales(planContext)" [label]="'Talk to sales' | textCase"
                            [size]="'lg'" [disabled]="!!organizationData.contactedSales" variant="filled"
                            severity="theme" [fullWidth]="true" />
                        } @else {
                        @if(shouldShowContactSales(originalPlan)) {
                        <app-button (clicked)="handleContactSales(planContext)" [label]="'Talk to sales' | textCase"
                            [size]="'lg'" [disabled]="isLoadingPlan(planContext) || organizationData.contactedSales"
                            [loading]="isLoadingPlan(planContext)" [enableThrottle]="true" variant="filled"
                            severity="theme" [fullWidth]="true" />
                        }
                        @if(shouldShowPriceToCustomer(originalPlan)) {
                        @if(isCurrentPlan(originalPlan) && orgHasPaid()) {
                        @if(orgIsActive()) {
                        <app-button (clicked)="openCustomerPortal()" [label]="'View subscription details' | textCase"
                            [size]="'lg'" variant="outlined" severity="theme" [loading]="ui.isLoadingPortal"
                            [disabled]="ui.isLoadingPortal" [fullWidth]="true" />
                        @if(canCancelSubscription) {
                        <app-button (clicked)="openCancelDialog()" [label]="'Cancel subscription' | textCase"
                            [size]="'lg'" variant="outlined" severity="danger" [fullWidth]="true" />
                        }
                        @if(orgIsCancelPending() && billingCycleEndDate) {
                        <app-button (clicked)="revokeSubscriptionCancellation()"
                            [label]="'Revoke cancellation' | textCase" [size]="'lg'" variant="filled" severity="theme"
                            [fullWidth]="true" />
                        <p class="text-xs text-center text-gray-500 m-0">
                            {{"Subscription cancels at" | textCase}} {{ billingCycleEndDate | date:'mediumDate' }}
                        </p>
                        }
                        @if(orgIsDowngradePending() && pendingDowngradeDate) {
                        <p class="text-xs text-center text-gray-500 m-0">
                            {{"Downgrade to" | textCase}} {{ pendingDowngradePlanName }} {{"scheduled for" | textCase}}
                            {{ pendingDowngradeDate | date:'mediumDate' }}
                        </p>
                        <app-button (clicked)="cancelScheduledDowngrade()" [label]="'Cancel downgrade' | textCase"
                            [size]="'lg'" variant="outlined" severity="danger" [fullWidth]="true" />
                        }
                        } @else {
                        <app-button (clicked)="handleCheckout(planContext)" [label]="'Renew subscription' | textCase"
                            [size]="'lg'" [disabled]="isLoadingPlan(planContext)" [loading]="isLoadingPlan(planContext)"
                            [enableThrottle]="true" variant="filled" severity="theme" [fullWidth]="true" />
                        }
                        } @else if(isCurrentPlan(originalPlan) && orgIsPaymentFailed()) {
                        <p class="text-xs text-center text-red-500 m-0">
                            {{"Your last payment failed. Please update your payment method." | textCase}}
                        </p>
                        <app-button (clicked)="openCustomerPortal()" [label]="'Retry payment' | textCase" [size]="'lg'"
                            variant="filled" severity="danger" [loading]="ui.isLoadingPortal"
                            [disabled]="ui.isLoadingPortal" [fullWidth]="true" />
                        }
                        @else {
                        <app-button (clicked)="handleCheckout(planContext)"
                            [label]="(isCurrentPlan(originalPlan) && orgHasSubscriptionEnded() ? 'Renew subscription' : 'Subscribe') | textCase"
                            [size]="'lg'" [disabled]="isLoadingPlan(planContext)" [loading]="isLoadingPlan(planContext)"
                            [enableThrottle]="true" variant="filled" severity="theme" [fullWidth]="true" />
                        }
                        }
                        @else if(isCurrentPlan(originalPlan) && orgHasSubscriptionEnded()) {
                        <app-button (clicked)="handlePlanAction(planContext)" [label]="'Renew subscription' | textCase"
                            [size]="'lg'" [disabled]="isLoadingPlan(planContext)" [loading]="isLoadingPlan(planContext)"
                            [enableThrottle]="true" variant="filled" severity="theme" [fullWidth]="true" />
                        }
                        }

                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>

<app-phone-number-dialog [(visible)]="showPhoneNumberDialog" (phoneNumberSubmitted)="onPhoneNumberSubmitted()">
</app-phone-number-dialog>